import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { UseFormReturn, useForm } from '@kanda-libs/ks-component-ts';
import { StringIndexedObject } from '@kanda-libs/ks-design-library';
import {
  InfoSearch,
  SearchIndex,
  actions,
} from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/shared/App';
import useApiError from 'hooks/useApiError';
import { selectors } from 'store';

export interface SearchForm {
  q: string;
  index: SearchIndex | 'all';
}

export interface SearchFormHook {
  form: UseFormReturn<SearchForm>;
  onSubmit: (values: StringIndexedObject<SearchForm>) => void;
  isSubmitting: boolean;
}

export default function useSearchForm(): SearchFormHook {
  const dispatch = useAppDispatch();
  const onError = useApiError(
    'Unknown error searching - refresh and try again',
  );

  const data = useSelector(selectors.infoSearch.getEntity);
  const isSubmitting = useSelector(selectors.infoSearch.getIsSubmitting);

  const form = useForm<SearchForm>();

  const onSubmit = useCallback(
    (vals: StringIndexedObject<SearchForm>) => {
      const values = vals as unknown as SearchForm;
      const { q, index: _index } = values;
      const index: SearchIndex[] =
        _index && _index !== 'all'
          ? [_index]
          : ['company', 'credit', 'enterprise', 'job'];
      const body = {
        q,
        index,
      };
      dispatch(
        actions.infoSearch({
          body,
          onError,
        }),
      );
    },
    [onError],
  );

  return {
    form,
    onSubmit,
    isSubmitting,
  };
}
